import React from 'react';
import { StringHelper } from '@src/services/helpers/string';
import { CollectionView } from 'common';
import { style } from 'typestyle';
import TitleBar from '../TitleBar';

interface IProps {
  collection: CollectionView
  onSelect: (collection: CollectionView) => void
}

export function ShareCollection({ collection, onSelect }: IProps) {
  const bgImage = collection.preview_media_url ?? null;
  const bgStyle = bgImage ? {
    backgroundImage: `url("${bgImage}")`,
  } : { backgroundColor: 'gray' };

  return (
    <TitleBar
      style={bgStyle}
      classes={[titleBarClass]}
      title={StringHelper.upperFirst(collection.name)}
      onSelect={() => onSelect(collection)}
    />
  );
}

const titleBarClass = style({
  position: 'relative',
});
